export const formatBillingEntityAttributes = (
  attributes: BillingEntity,
): BillingEntity => {
  return {
    ...attributes,
    nominated_billing_period_offset_weeks:
      attributes.nominated_billing_period_offset_weeks.toString(),
  };
};
